<template>
  <div style="border-top: 1px solid #e2e2e2; padding: 20px 0">
    <el-form
      :model="state.model"
      label-width="auto"
      label-position="top"
      ref="formDom"
    >
      <el-form-item
        label="表格文件(仅支持.xlsx文件)"
        prop="file"
        :rules="[
          { required: true, message: '请选择表格文件', trigger: 'blur' },
        ]"
      >
        <div
          style="
            display: flex;
            align-items: center;
            column-gap: 10px;
            width: 100%;
          "
        >
          <el-input
            v-model="state.fileName"
            size="large"
            placeholder="--请选择文件--"
            readonly
            style="flex: 1"
          ></el-input>
          <el-upload
            action="#"
            :show-file-list="false"
            ref="uploadDom"
            accept=".xlsx"
            :auto-upload="false"
            :on-change="onFileChange"
          >
            <template #default>
              <el-button type="primary" size="large"> 选择文件 </el-button>
            </template>
          </el-upload>
        </div>
      </el-form-item>
      <el-form-item
        label="子表"
        prop="import_sheet"
        :rules="[
          { required: true, message: '请选择要导入的子表', trigger: 'blur' },
        ]"
        v-if="state.sheetsData?.length > 0"
      >
        <el-select
          size="large"
          v-model="state.model.import_sheet"
          placeholder="请选择要导入的子表"
        >
          <el-option
            v-for="(item, index) in state.sheetsData"
            :key="item"
            :label="item"
            :value="index + 1"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
  <div style="display: flex; align-items: center; justify-content: center">
    <el-button type="success" @click="onSubmitImport">确定导入</el-button>
    <el-button type="warning" @click="onDownLoad">模板下载</el-button>
  </div>
</template>

<script>
import { onMounted, reactive, getCurrentInstance, ref } from "vue";
import {
  customer_subaccount_download,
  customer_subaccount_import,
} from "@/http/customer";
import { ElMessage, ElMessageBox } from "element-plus";
import * as XLSX from "xlsx";
export default {
  props: {
    customer_id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const { proxy } = getCurrentInstance();
    const state = reactive({
      model: {
        customer_id: props.customer_id,
      },
    });
    onMounted(() => {});

    //选择文件
    const onFileChange = (file) => {
      state.fileName = file.name;
      state.model.file = file.raw;

      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        state.sheetsData = workbook.SheetNames;
        if (state.sheetsData?.length > 0) state.model.import_sheet = 1;
      };
      reader.readAsArrayBuffer(file.raw);
    };

    const onSubmitImport = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          const formData = new FormData();
          //把接口需要的参数带进去
          formData.append("customer_id", props.customer_id);
          formData.append("import_sheet", state.model.import_sheet);
          formData.append("file", state.model.file);
          customer_subaccount_import(formData)
            .then((res) => {
              if (res.status == 200) {
                ElMessageBox.alert(res.data?.msg, "导入结果通知", {
                  type: "success",
                  confirmButtonText: "确定",
                  dangerouslyUseHTMLString: true,
                  callback: () => {
                    emit("success", true);
                  },
                });
              }
            })
            .catch((err) => {
              ElMessageBox.confirm(`${err.data.msg}`, "导入异常", {
                confirmButtonText: "关闭",
                cancelButtonText: "复制异常信息",
                confirmButtonClass: "el-button--danger",
                distinguishCancelAndClose: true,
                dangerouslyUseHTMLString: true,
                type: "error",
                beforeClose: (action, ins, done) => {
                  if (action == "confirm") {
                    done();
                  } else if (action == "cancel") {
                    proxy.$onCopy(err.data.msg);
                  } else {
                    done();
                  }
                },
              });
            });
        }
      });
    };

    const onDownLoad = () => {
      customer_subaccount_download()
        .then((res) => {
          if (res.status == 200) {
            let fileName = decodeURI(
              res.headers["content-disposition"].split("=")[1],
            );

            //通过后台返回 的word文件流设置文件名并下载
            var blob = new Blob([res.data], {
              type: res.data.type,
            });
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = fileName; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
          }
        })
        .catch((err) => {
          const fileReader = new FileReader();
          fileReader.readAsText(
            new Blob([err.data], { type: "application/octet-stream" }),
            "utf-8",
          );
          fileReader.onload = () => {
            const msg = JSON.parse(fileReader.result);
            ElMessage.error(msg?.msg);
          };
        });
    };

    return {
      state,
      onFileChange,
      onSubmitImport,
      onDownLoad,
      formDom,
    };
  },
};
</script>
<style scoped></style>
